import { render, staticRenderFns } from "./ProductModalWidget.vue?vue&type=template&id=bbd6d466&scoped=true&"
import script from "./ProductModalWidget.vue?vue&type=script&lang=js&"
export * from "./ProductModalWidget.vue?vue&type=script&lang=js&"
import style0 from "./ProductModalWidget.vue?vue&type=style&index=0&id=bbd6d466&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd6d466",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBadge,VBtn,VCard,VCardText,VCol,VDialog,VIcon,VRow,VTextarea})
